import { render } from "./accept_m_in_users_from_cashier.vue?vue&type=template&id=18f22c0b&scoped=true"
import script from "./accept_m_in_users_from_cashier.vue?vue&type=script&lang=js"
export * from "./accept_m_in_users_from_cashier.vue?vue&type=script&lang=js"

import "./accept_m_in_users_from_cashier.vue?vue&type=style&index=0&id=18f22c0b&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f22c0b"]])

export default __exports__